enum BillingsTaxiRouteListingViewMode {
  TAXI = "TAXI",
  RAILY = "RAILY",
}

export default BillingsTaxiRouteListingViewMode;
